import { render, staticRenderFns } from "./item-checker.vue?vue&type=template&id=f5da7c1c&scoped=true"
import script from "./item-checker.vue?vue&type=script&lang=js"
export * from "./item-checker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5da7c1c",
  null
  
)

export default component.exports